import type {DocumentQuery} from '@sdox/api'

interface DocumentTypeContentProps {
  data: Extract<DocumentQuery['document'], {__typename: 'MobRecordType'}>
}

// This component is not implemented in the Proof of Concept stage
export const MobRecordTypeContent = (props: DocumentTypeContentProps) => {
  const {data} = props
  return (
    <div>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  )
}
